const ROUTE_VALUE_TO_API = {

  "user-management": "user management",

  "course-management": "course management",

  "student-progress": "student progress",

  "manage-requests": "manage requests",

  "manage-payments": "manage payments",

  "activity-log": "activity log",

  "deletion-history": "deletion history",

  "manage-plans": "website management",

};



const PERMISSION_VALUE_TO_API = {

  add: "write",

  update: "update",

  delete: "delete",

};



const API_PERMISSION_TO_VALUE = {

  write: "add",

  update: "update",

  delete: "delete",

};



export const buildRoutePermissionPayload = (selectedPermissions = {}) => {

  const routePermissionMap = {};



  Object.entries(selectedPermissions)

    .filter(([, permissions]) => Array.isArray(permissions) && permissions.length > 0)

    .forEach(([routeKey, permissions]) => {

      const apiRoute = ROUTE_VALUE_TO_API[routeKey];

      if (!apiRoute) {

        return;

      }



      if (!routePermissionMap[apiRoute]) {

        routePermissionMap[apiRoute] = new Set();

      }



      permissions.forEach((permission) => {
        const apiPermission = PERMISSION_VALUE_TO_API[permission];
        if (apiPermission) {
          routePermissionMap[apiRoute].add(apiPermission);
        }
      });

      if (routePermissionMap[apiRoute].size > 0) {
        routePermissionMap[apiRoute].add("read");
      }

    });



  return Object.entries(routePermissionMap)

    .filter(([, permissions]) => permissions.size > 0)

    .map(([route, permissions]) => ({

      route,

      permissions: [...permissions],

    }));

};



const API_ROUTE_TO_VALUE = Object.fromEntries(

  Object.entries(ROUTE_VALUE_TO_API).map(([key, value]) => [value, key]),

);



export const mapApiRoutePermissionsToSelected = (

  routePermissions = [],

  permissionOptions = [],

) => {

  const result = {};



  if (!Array.isArray(routePermissions)) {

    return result;

  }



  routePermissions.forEach(({ route, permissions }) => {

    const routeKey = API_ROUTE_TO_VALUE[route];

    if (!routeKey) {

      return;

    }



    const option = permissionOptions.find((item) => item.value === routeKey);

    if (!option) {

      return;

    }



    const selectedSubOptions = [];



    (permissions || []).forEach((apiPermission) => {

      const uiValue = API_PERMISSION_TO_VALUE[apiPermission];

      if (uiValue && !selectedSubOptions.includes(uiValue)) {

        selectedSubOptions.push(uiValue);

      }

    });



    if (selectedSubOptions.length > 0) {

      result[routeKey] = selectedSubOptions;

    }

  });



  return result;

};


